const messages = {
  'page.forgot-password.meta.title': 'Forgotten password',
  'page.forgot-password.meta.description':
    "Let us know the email address you signed up with and we'll send you a link to reset your password",
  'page.forgot-password.title': 'Forgotten password',
  'page.forgot-password.description':
    "Let us know the email address you signed up with and we'll send you a link to reset your password",
  'page.forgot-password.loading': 'Sending link to reset your password',
  'page.forgot-password.form.email': 'Email address',
  'page.forgot-password.sent.title': 'Reset password link sent',
  'page.forgot-password.error':
    "Whoops, there's been a problem trying to reset your password. Please try again.",
  'page.forgot-password.sent.button-resend': 'Resend reset password link',
  'page.forgot-password.sent.button-sign-in': 'Sign in',
  'page.forgot-password.link.back-to-sign': 'Back to sign in',
  'page.forgot-password.sent.description':
    'A reset password message has been sent to your email address. Click the link to reset your password',
  'page.forgot-password.sent.spam-message':
    'If you do not receive the message within a few moments, please check your spam folder.',
}

export default messages
